import { FC } from "react";
import GoBackButton from "@/components/go-back-button";
import Layout from "@/components/layout";
import { Routes } from "@/types/routes";
import { useNavigate } from "react-router-dom";
import styles from "./index.module.scss";
import ChosenTimeSlot from "./ChosenTimeSlot";
import Receipt from "@/components/receipt";
import { useTranslation } from "react-i18next";
import YourInfoForm from "./YourInfoForm";
import { Button } from "@/components/button";
import usePickupStore from "@/stores/pickup";
import { StillThereModal } from "@/components/still-there-modal";
import { useAppSelector } from "@/hooks/useAppSelector";
import {
  selectCartProducts,
  selectCartTotal,
  selectCartDiscounts,
  selectCartProductsTotal,
} from "@/store/cart/selectors";

const YourInfoPage: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const cartProducts = useAppSelector(selectCartProducts);
  const cartDiscounts = useAppSelector(selectCartDiscounts);
  const productTotal = useAppSelector(selectCartProductsTotal);
  const cartTotal = useAppSelector(selectCartTotal);
  const { validateCustomer } = usePickupStore();

  const onBackClick = () => navigate(Routes.PICK_UP_TIME_SLOT);
  const onContinue = () => {
    if (validateCustomer()) navigate(Routes.CHECKOUT);
  };

  return (
    <Layout childrenClassName={styles.container}>
      <GoBackButton onClick={onBackClick} className={styles.backButton} />
      <h1>{t("pickup.yourInfoPage.yourInfo")}</h1>
      <ChosenTimeSlot />
      <div className={styles.contentRow}>
        <YourInfoForm className={styles.contentBox} />
        <Receipt
          products={cartProducts}
          discounts={cartDiscounts}
          productTotalAmountCents={productTotal}
          amountCents={cartTotal}
          className={styles.contentBox}
        />
      </div>
      <Button
        text={t("pickup.yourInfoPage.pay")}
        className={styles.button}
        onClick={onContinue}
        data-cy="continue-button"
      />
      <StillThereModal />
    </Layout>
  );
};

export default YourInfoPage;
